"use client";

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../../../../components/navbar";
import Footer from "../../../../../components/footer";
import Button from "../../../../../components/Button";
import styles from "../css/splitPayment.module.css";
import { LuBanknote, LuFileText, LuBuilding2, LuHeartPulse } from "react-icons/lu";
import { FiCreditCard, FiTruck, FiSmartphone } from "react-icons/fi";

export default function SplitPaymentStep1View() {
  const location = useLocation();
  const navigate = useNavigate();
  const [total, setTotal] = useState(0);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (location.state && typeof location.state.total === "number") {
      setTotal(location.state.total);
      return;
    }

    try {
      const raw = localStorage.getItem("frontshop_basket");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          const subtotal = parsed.reduce(
            (sum, item) => sum + (Number(item.price) || 0) * (Number(item.qty) || 0),
            0
          );
          const tax = subtotal * 0.15;
          setTotal(subtotal + tax);
        }
      }
    } catch {
      // ignore storage parse errors
    }
  }, [location.state]);

  const displayAmount = total.toFixed(2);
  const fromDebtors = !!(location.state && location.state.fromDebtors);

  const handleBack = () => {
    navigate("/frontshop/payment-types", {
      state: { total, fromDebtors },
    });
  };

  const baseMethods = [
    { id: "cash", label: "Cash", icon: LuBanknote, className: styles.cash },
    { id: "card", label: "Card", icon: FiCreditCard, className: styles.card },
    { id: "nedbank", label: "Nedbank", icon: LuBuilding2, className: styles.nedbank },
    { id: "ikhokha", label: "Ikhokha", icon: FiSmartphone, className: styles.ikhokha },
    { id: "medicalAid", label: "Medical Aid", icon: LuHeartPulse, className: styles.medicalAid },
  ];

  const methods = fromDebtors
    ? baseMethods.filter((m) =>
        ["cash", "card", "nedbank", "ikhokha"].includes(m.id)
      )
    : baseMethods;

  const methodsLayoutClass = fromDebtors
    ? styles.methodsGridFour
    : methods.length === 5
    ? styles.methodsGridFive
    : "";

  const handleContinue = () => {
    if (!selected) return;

    if (selected === "medicalAid") {
      navigate("/frontshop/payment-types/split/medical-aid/profiles", {
        state: { total, method1: selected, fromDebtors },
      });
      return;
    }

    if (selected === "cash") {
      navigate("/frontshop/payment-types/split/method1=cash", {
        state: { total, splitFlow: true, method1: "cash", fromDebtors },
      });
      return;
    }

    if (selected === "card") {
      navigate("/frontshop/payment-types/split/method1=card", {
        state: {
          total,
          splitFlow: true,
          method1: "card",
          fromDebtors,
          paymentMethod: "Card",
        },
      });
      return;
    }

    if (selected === "nedbank") {
      navigate("/frontshop/payment-types/split/method1=nedbank", {
        state: {
          total,
          splitFlow: true,
          method1: "nedbank",
          fromDebtors,
          paymentMethod: "Nedbank",
        },
      });
      return;
    }

    if (selected === "ikhokha") {
      navigate("/frontshop/payment-types/split/method1=ikhokha", {
        state: {
          total,
          splitFlow: true,
          method1: "ikhokha",
          fromDebtors,
          paymentMethod: "Ikhokha",
        },
      });
      return;
    }

    if (selected === "cod") {
      navigate("/frontshop/payment-types/split/method1=cod", {
        state: { total, splitFlow: true, method1: "cod", fromDebtors },
      });
      return;
    }

    if (selected === "credit") {
      navigate("/frontshop/payment-types/split/method1=credit", {
        state: { total, splitFlow: true, method1: "credit", fromDebtors },
      });
      return;
    }

    navigate("/frontshop/payment-types/split/step2", {
      state: { total, method1: selected, fromDebtors },
    });
  };

  return (
    <div className={styles.wrapper}>
      <Navbar onBack={handleBack} />

      <main className={styles.main}>
        <div className={styles.contentCard}>
          <header className={styles.header}>
            <h1 className={styles.title}>Split Payment</h1>
            <p className={styles.subtitle}>
              Total Amount: <span className={styles.amount}>R {displayAmount}</span>
            </p>
          </header>

          <p className={styles.stepLabel}>Select method 1 to split between:</p>

          <section
            className={`${styles.methodsGrid} ${methodsLayoutClass}`}
          >
            {methods.map((method) => {
              const Icon = method.icon;
              const isSelected = selected === method.id;
              return (
                <button
                  key={method.id}
                  type="button"
                  className={`${styles.methodCard} ${method.className} ${
                    isSelected ? styles.methodCardSelected : ""
                  }`}
                  onClick={() => setSelected(method.id)}
                >
                  <div className={styles.iconWrap}>
                    <Icon />
                  </div>
                  <div className={styles.methodLabel}>{method.label}</div>
                </button>
              );
            })}
          </section>

          <div className={styles.continueRow}>
            <Button
              type="button"
              variant="approve"
              className={styles.continueButton}
              onClick={handleContinue}
            >
              Continue to payment
            </Button>
          </div>
        </div>
      </main>

      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
}
